import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  tokenKey: "",
};

const plainAxios = axios.create({
  baseURL: BASE_URL,
  headers: { Accept: "application/json" },
});

export const getAuthToken = createAsyncThunk(
  "token/getAuthToken",
  async (params, { rejectWithValue }) => {
    try {
      const response = await plainAxios.get("get-token");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const authTokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {},
  extraReducers: {
    [getAuthToken.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getAuthToken.fulfilled]: (state, action) => {
      state.status = "succeeded";
      localStorage.setItem("authToken", action.payload.data.token);
    },
    [getAuthToken.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default authTokenSlice.reducer;
